import * as CryptoJS from 'crypto-js';

/**
 * Hashes a telemetry ID and maps it to a value between 0 and 1.
 *
 * @param id - The telemetry ID to hash.
 * @returns A number between 0 and 1 based on the hash value.
 */
const hashTelemetryId = id => {
  const hash = CryptoJS.SHA256(id).toString(CryptoJS.enc.Hex);
  return Number.parseInt(hash.slice(0, 8), 16) / 0xffffffff;
};
/**
 * Creates a fixed-rate sampler function to determine if telemetry should be kept
 * based on a hash of its ID and a specified sampling rate.
 *
 * @param samplingRate - Sampling rate as a percentage (e.g., 10 for 10%, 1 for 1%).
 * @returns A sampler function that takes an optional telemetry ID and returns `true` if the telemetry is kept, `false` otherwise.
 */
export const createFixedRateSampler = percentage => {
  // Convert percentage to a decimal sampling rate
  const samplingRate = percentage / 100;

  /**
   * Sampler function to decide whether to include telemetry based on its ID.
   *
   * @param id - The telemetry ID (e.g., operation ID or custom data ID). If `undefined`, a random fallback is used.
   * @returns `true` if the telemetry should be kept, `false` otherwise.
   */
  return id => {
    if (!id) {
      return Math.random() < samplingRate; // Fallback for missing IDs
    }
    const hashValue = hashTelemetryId(id);
    return hashValue < samplingRate; // Include if hash value is within the sampling rate
  };
};
//# sourceMappingURL=createFixedRateSampler.js.map